var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRowEdit = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 21,
  viewBox: "0 0 21 21",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h21v21H0z"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "m12.625 5.872 2.232 2.231-7.034 7.035-3.72 1.488 1.487-3.72z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.753 4.5a1.573 1.573 0 0 1 1.578 1.579c0 .404-.154.808-.462 1.116L14.753 8.31 12.52 6.08l1.115-1.117a1.57 1.57 0 0 1 1.117-.462z"
})))));
export { SvgRowEdit as ReactComponent };
export default __webpack_public_path__ + "assets/images/row-edit.svg";